import { render, staticRenderFns } from "./SuccessCard.vue?vue&type=template&id=16a1d170&scoped=true&"
import script from "./SuccessCard.vue?vue&type=script&lang=ts&"
export * from "./SuccessCard.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessCard.vue?vue&type=style&index=0&id=16a1d170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1d170",
  null
  
)

export default component.exports